<script>
export default {
    props : {
        continueButton : {
            type: Boolean,
            required : true,
        },
        specs: {
            type : Object,
            required : true,
        },
        currentSpecs : {
            type : Object,
            default: null
        }
    },
    data :  () => ({
        filterIds : ["37501", "14801", "21001","23301", "12604","41201","21007","22807","24102","7501", "45001", "3101", "12503", "12506", "13001", "13301", "42005", "25201", "44801", "1328", "1330", "46907", "46906", "59803", "59802", "59806", "37701", "17402", "16601", "15601", "18001", "17501", "30701", "3202", "5601", "53001", "33801", "42201", "16401", "44401", "19401", "13801", "16301", "41401", "13401", "46501", "20603", "6502"],
        selectedSpecs : [],
    }),
    computed : {
        filterSpecs() {
            let _this = this;
            return _.pickBy(this.specs, function (value, key) {
                return _this.filterIds.includes(key);
            });
        },
        emptySpecs() {
            return Object.entries(this.specs).length === 0;
        }
    },
    watch : {
        filterSpecs(newValue, oldValue) {
            if(Object.entries(newValue).length !== 0) {
                this.selectedSpecs = Object.keys(newValue);
            }
        },
        currentSpecs(newValue, oldValue) {
            if(Object.entries(newValue).length !== 0) {
                this.selectedSpecs = Object.keys(newValue);
            }
        },
        selectedSpecs(newValue, oldValue) {
            let childSelectedSpecs = _.pickBy(this.specs, function (value, key) {
                return newValue.includes(key);
            });
            this.$emit('specsChange', childSelectedSpecs);
        }
    },
}
</script>

<template>
<div class="box__body">
    <hr>
    <span class="opacity-60 tx-center block w-full pt-10 md:pt-20" v-if="emptySpecs">No hay información del modelo</span>
    <div class="characteristics__grid pt-6 md:pt-14">
        <div class="item" v-for="(spec, index) in filterSpecs" :key="index">
            <input class="check-mod" :value="index" :id="index" v-model="selectedSpecs" type="checkbox" >
            <label class="h-full" :for="index">
                <div>
                    <span class="block tx-12 tx-dark-ad ff-montserrat-bold  mb-1">
                        {{spec.value !== "serie" && spec.value !== "-" && spec.value !== "incluido" && spec.value !== "si"? spec.parentName + ", " + spec.name : spec.category + ", " + spec.parentName}}
                    </span>
                    <span >
                        {{spec.value !== "serie" && spec.value !== "-" && spec.value !== "incluido"&& spec.value !== "si"? spec.value : spec.name}}
                    </span>
                </div>
                <span class="mask-check">
                    <img src="/assets/images/helpers/icon-check-white.svg" alt="">
                </span>
            </label>
        </div>
    </div>
    <!-- BTN NEXT -->
    <div v-show="continueButton" @click="$emit('next')" class="btn btn--green-ad btn--next weight-700 flex mx-a sm:mr-0 mt-8">
        Continuar
    </div>
</div>
</template>
